import { ReplaySubject } from 'rxjs';
export class BaseComponent {
    constructor() {
        this.destroyed$ = new ReplaySubject();
    }
    destroy() {
        if (this.destroyed$) {
            this.destroyed$.next();
            this.destroyed$.complete();
        }
    }
}
